import { useCallback, useEffect, useRef, useState } from "react";
import api from "./api";

// PR keamanan lanjutan B (INSTRUKSI 29/10/2026 butir 7): Cloudflare Turnstile di Daftar & Lupa sandi. Site key dari server
// (GET /api/auth/turnstile; kosong = Turnstile mati → formulir bekerja seperti sebelumnya). Skrip resmi dimuat sekali (mode explicit,
// tanpa script inline; CSP mengizinkan challenges.cloudflare.com untuk script & frame). Token sekali pakai → reset() sesudah setiap kirim.
const SKRIP = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
let kunciJanji = null;
let skripJanji = null;

let dataJanji = null;
/** Isi GET /api/auth/turnstile (site_key + login_google, PR login Google), satu permintaan dibagi; gagal = null dan dimuat ulang lain kali. */
export function ambilDataAuth() {
  if (!dataJanji) dataJanji = api.get("/api/auth/turnstile").then(({ data }) => (data && typeof data === "object" ? data : {})).catch(() => { dataJanji = null; return null; });
  return dataJanji;
}
export function ambilSiteKey() {
  if (!kunciJanji) {
    // review Codex B2 putaran 1: gagal memuat ≠ Turnstile mati → null (bukan ""), formulir menahan kiriman dan memuat ulang saat dicoba lagi
    kunciJanji = ambilDataAuth().then((data) => { if (data === null) { kunciJanji = null; return null; } return String(data.site_key || ""); });
  }
  return kunciJanji;
}
function muatSkrip() {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (!skripJanji) {
    skripJanji = new Promise((ok, gagal) => {
      const s = document.createElement("script");
      s.src = SKRIP;
      s.async = true;
      s.onload = () => (window.turnstile ? ok(window.turnstile) : gagal(new Error("turnstile")));
      s.onerror = () => { skripJanji = null; gagal(new Error("turnstile")); };
      document.head.appendChild(s);
    });
  }
  return skripJanji;
}
/** Hanya untuk tes */
export function _setUlang() { kunciJanji = null; skripJanji = null; dataJanji = null; }

/**
 * aksi = "daftar" | "lupa_sandi" (dicek server). Hasil: { ref (ref callback untuk <div> wadah), aktif, token, siap (boleh kirim), reset() }.
 * Turnstile mati → aktif false, siap true, token "".
 */
export function useTurnstile(aksi) {
  const [el, ref] = useState(null);   // ref callback: wadah bisa berganti (mis. langkah "minta" → "periksa" di Lupa sandi)
  const widget = useRef(null);
  const [kunci, setKunci] = useState(null);   // null = memuat
  const [token, setToken] = useState("");
  const [galat, setGalat] = useState(false);
  const [gagalMuat, setGagalMuat] = useState(false);   // GET /api/auth/turnstile gagal (jaringan) — bukan "mati"
  const [muatKe, setMuatKe] = useState(0);

  useEffect(() => {
    let hidup = true;
    ambilSiteKey().then((k) => { if (!hidup) return; if (k === null) setGagalMuat(true); else { setGagalMuat(false); setKunci(k); } });
    return () => { hidup = false; };
  }, [muatKe]);
  useEffect(() => {
    if (!kunci || !el) return undefined;
    let hidup = true;
    setToken("");
    muatSkrip().then((ts) => {
      if (!hidup || widget.current !== null) return;
      widget.current = ts.render(el, {
        sitekey: kunci, action: aksi, theme: "light", language: "id",
        callback: (t) => { setToken(t); setGalat(false); },
        "expired-callback": () => setToken(""),
        "error-callback": () => { setToken(""); setGalat(true); },
      });
    }).catch(() => { if (hidup) setGalat(true); });
    return () => {
      hidup = false;
      if (widget.current !== null && window.turnstile) { try { window.turnstile.remove(widget.current); } catch { /* sudah dilepas */ } }
      widget.current = null;
    };
  }, [kunci, aksi, el]);

  const reset = useCallback(() => {
    setToken("");
    if (widget.current !== null && window.turnstile) { try { window.turnstile.reset(widget.current); } catch { /* abaikan */ } }
  }, []);
  const aktif = !!kunci;
  /** Pesan saat belum boleh kirim; bila pengaturan gagal dimuat sekalian dimuat ulang (tombol kirim = coba lagi). */
  const pesanBelumSiap = useCallback(() => {
    if (gagalMuat) { setGagalMuat(false); setMuatKe((n) => n + 1); return PESAN_GAGAL_MUAT; }
    return PESAN_VERIFIKASI;
  }, [gagalMuat]);
  return { ref, aktif, token, galat, siap: kunci === "" || (aktif && !!token), memuat: kunci === null && !gagalMuat, gagalMuat, pesanBelumSiap, reset };
}

export const PESAN_VERIFIKASI = "Selesaikan verifikasi keamanan terlebih dahulu.";
export const PESAN_GAGAL_MUAT = "Verifikasi keamanan belum termuat. Periksa koneksi, lalu tekan tombol sekali lagi.";
